import { Button, Dialog, DialogActions, DialogContent, IconButton, makeStyles, Menu, MenuItem } from "@material-ui/core";
import React from "react";
import BlockUser from "../../../blockUser";
import config from "../../../../config";
import MoreVertIcon from '@material-ui/icons/MoreVert';
import httpUtils from "../../../../utils/http.utils";
import UserModal from "../../../userModal";
import { dispatch } from "../../../../events";
import { types } from "../../../../events/loader";
import Feed from "../../../feed";
import { dateTimeToString } from "../../../../utils/date.utils";
import UserName from "../../../userName";

const useStyles = makeStyles((theme) => ({
    comment: {
        textAlign: 'left',
        margin: '10px 15px 10px 15px',
        padding: '5px',
        backgroundColor: '#dbdbdb',
        borderRadius: '7px',
        '&:hover': {
            cursor: 'pointer'
        }
    },
    commentDate: {
        textAlign: 'center'
    }
}));

const ITEM_HEIGHT = 48;

const CommentCard = ({ comment, onDelete, onClick }) => {
    const classes = useStyles();

    const [openBlockModal, setOpenBlockModal] = React.useState(false);
    const [openUserDataModal, setOpenUserDataModal] = React.useState(false);
    const [openRelatedObject, setOpenRelatedObject] = React.useState(false);
    const [relatedObject, setRelatedObject] = React.useState(undefined);

    // Menu
    const [anchorEl, setAnchorEl] = React.useState(null);
    const openMenu = Boolean(anchorEl);
    const handleMenuClick = (event) => {
        event.stopPropagation();
        setAnchorEl(event.currentTarget);
    };
    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    const deleteComment = async () => {
        handleMenuClose();
        dispatch(types.SET_LOADER);
        await httpUtils.delete(`${config.BACK_API}/api/comment/${comment.id}`);
        dispatch(types.UNSET_LOADER);
        onDelete();
    }

    const blockUser = async () => {
        handleMenuClose();
        setOpenBlockModal(true);
    }

    const userData = async () => {
        handleMenuClose();
        setOpenUserDataModal(true);
    }

    const deleteReported = async () => {
        handleMenuClose();
        dispatch(types.SET_LOADER);
        await httpUtils.delete(`${config.BACK_API}/api/report/objectId/${comment.id}`);
        dispatch(types.UNSET_LOADER);
        onDelete(comment);
    }

    const showRelatedObject = async () => {
        handleMenuClose();
        if (comment.objectType === 'Feed') {
            const response = await httpUtils.get(`${config.BACK_API}/api/feed/${comment.objectId}`);
            setRelatedObject(response.data);
            setOpenRelatedObject(true);
        }
    }

    const onDeleteRelatedObject = () => {
        setOpenRelatedObject(false);
        onDelete(comment);
    }

    return (
        <div className={classes.comment} onClick={onClick}>
            <IconButton
                aria-label="more"
                aria-controls="long-menu"
                aria-haspopup="true"
                onClick={handleMenuClick}
                className={classes.cardMenu}
            >
                <MoreVertIcon />
            </IconButton>
            <Menu
                anchorEl={anchorEl}
                keepMounted
                open={openMenu}
                onClose={handleMenuClose}
                PaperProps={{
                    style: {
                        maxHeight: ITEM_HEIGHT * 4.5,
                        width: '20ch',
                    },
                }}
            >
                <MenuItem key="Delete" onClick={deleteComment}>
                    Delete
                </MenuItem>
                <MenuItem key="block" onClick={blockUser}>
                    Block user
                </MenuItem>
                <MenuItem key="block" onClick={userData}>
                    User data
                </MenuItem>
                {comment.reported && (
                    <>
                        <MenuItem key="block" onClick={deleteReported}>
                            Delete report
                        </MenuItem>
                        <MenuItem key="block" onClick={showRelatedObject}>
                            Open related object
                        </MenuItem>
                    </>
                )}
            </Menu>
            <UserName user={comment.user} strong={true} /> {comment.text}
            <br />
            <p className={classes.commentDate}>{dateTimeToString(comment.createdAt)}</p>
            {openBlockModal && <BlockUser user={comment.user} onClose={() => setOpenBlockModal(false)} />}
            {openUserDataModal && <UserModal user={comment.user} onClose={() => setOpenUserDataModal(false)} />}
            <Dialog
                open={openRelatedObject}
                onClose={() => setOpenRelatedObject(false)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogContent>
                    {comment.objectType === 'Feed' && !!relatedObject && (
                        <Feed feed={relatedObject} onDelete={onDeleteRelatedObject} />
                    )}
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpenRelatedObject(false)} color="primary">
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}

export default CommentCard;